import type { Lang } from "@/i18n/strings";

/**
 * pickLang - waehlt zwischen deutschem Basisfeld und englischer _en-Variante.
 * Bei lang === "en" wird das _en-Feld bevorzugt; ist es leer oder null,
 * faellt die Funktion automatisch auf das deutsche Basisfeld zurueck.
 * Bei lang === "de" wird immer das Basisfeld geliefert.
 */
export function pickLang(
  row: object | null | undefined,
  field: string,
  lang: Lang,
): string | null {
  if (!row) return null;
  const rec = row as Record<string, unknown>;
  const de = rec[field] as string | null | undefined;
  if (lang === "en") {
    const en = rec[`${field}_en`] as string | null | undefined;
    if (en != null && String(en).trim() !== "") return en;
  }
  return de ?? null;
}
